import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function Pagination({ page, pageSize, total, onPageChange }) {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between mt-4 pt-3 border-t border-white/5" data-testid="pagination">
      <p className="text-[10px] text-[#A1A1AA]">
        Showing {(page - 1) * pageSize + 1}-{Math.min(page * pageSize, total)} of {total}
      </p>
      <div className="flex items-center gap-1">
        <button
          data-testid="pagination-prev"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="p-1.5 rounded-md text-[#A1A1AA] hover:text-white hover:bg-white/5 transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <CaretLeft size={14} />
        </button>
        {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
          let pageNum;
          if (totalPages <= 5) {
            pageNum = i + 1;
          } else if (page <= 3) {
            pageNum = i + 1;
          } else if (page >= totalPages - 2) {
            pageNum = totalPages - 4 + i;
          } else {
            pageNum = page - 2 + i;
          }
          return (
            <button
              key={pageNum}
              data-testid={`pagination-page-${pageNum}`}
              onClick={() => onPageChange(pageNum)}
              className={`w-7 h-7 rounded-md text-xs font-bold transition-colors ${
                page === pageNum
                  ? "bg-[#00E5FF] text-black"
                  : "text-[#A1A1AA] hover:text-white hover:bg-white/5"
              }`}
            >
              {pageNum}
            </button>
          );
        })}
        <button
          data-testid="pagination-next"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="p-1.5 rounded-md text-[#A1A1AA] hover:text-white hover:bg-white/5 transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <CaretRight size={14} />
        </button>
      </div>
    </div>
  );
}
